// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analytics-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.analytics-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 20px;
}

.analytics-header h1 {
  color: #2c3e50;
  margin: 0;
}

.analytics-controls {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.period-selector {
  display: flex;
  align-items: center;
  gap: 10px;
}

.period-selector label {
  font-weight: 600;
  color: #555;
}

.period-selector select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: white;
  min-width: 150px;
}

.compare-toggle label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #555;
  cursor: pointer;
}

.compare-toggle input[type="checkbox"] {
  margin: 0;
}

.refresh-btn {
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
}

.refresh-btn:hover:not(:disabled) {
  background: #2980b9;
}

.refresh-btn:disabled {
  background: #bdc3c7;
  cursor: not-allowed;
}

.analytics-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.overview-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  text-align: center;
  border-left: 4px solid #3498db;
}

.overview-card h3 {
  margin: 0 0 10px 0;
  color: #7f8c8d;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
}

.overview-value {
  font-size: 2rem;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
}

.analytics-charts {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}

.chart-section {
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.chart-section h2 {
  margin: 0 0 20px 0;
  color: #2c3e50;
  font-size: 1.3rem;
  border-bottom: 2px solid #ecf0f1;
  padding-bottom: 10px;
}

.zipcodes-details {
  background: white;
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.zipcodes-details h2 {
  margin: 0 0 20px 0;
  color: #2c3e50;
  font-size: 1.3rem;
  border-bottom: 2px solid #ecf0f1;
  padding-bottom: 10px;
}

.zipcodes-table {
  overflow-x: auto;
}

.zipcodes-table table {
  width: 100%;
  border-collapse: collapse;
}

.zipcodes-table th,
.zipcodes-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ecf0f1;
}

.zipcodes-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}

.zip-code {
  font-family: monospace;
  font-weight: bold;
  color: #e74c3c;
}

.view-bookkeepers-btn {
  padding: 6px 12px;
  background: #27ae60;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.view-bookkeepers-btn:hover {
  background: #219a52;
}

.loading-spinner {
  text-align: center;
  padding: 40px;
  font-size: 1.1rem;
  color: #7f8c8d;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .analytics-charts {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .analytics-page {
    padding: 10px;
  }

  .analytics-header {
    flex-direction: column;
    align-items: stretch;
  }

  .analytics-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .period-selector {
    justify-content: space-between;
  }

  .analytics-overview {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .analytics-overview {
    grid-template-columns: 1fr;
  }
  
  .overview-value {
    font-size: 1.5rem;
  }
}
/* Add to existing Analytics.css */

.comparison {
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 5px;
}

.comparison.positive {
  color: #27ae60;
}

.comparison.negative {
  color: #e74c3c;
}

.overview-value {
  position: relative;
}

.comparison-note {
  background: #e3f2fd;
  border: 1px solid #2196f3;
  border-radius: 4px;
  padding: 10px;
  margin-top: 10px;
  font-size: 14px;
  color: #1565c0;
}

.comparison-period {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 10px 0;
  font-size: 14px;
  color: #856404;
}`, "",{"version":3,"sources":["webpack://./src/pages/Analytics.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;AACA,kCAAkC;;AAElC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,cAAc;AAChB","sourcesContent":[".analytics-page {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.analytics-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.analytics-header h1 {\n  color: #2c3e50;\n  margin: 0;\n}\n\n.analytics-controls {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.period-selector {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.period-selector label {\n  font-weight: 600;\n  color: #555;\n}\n\n.period-selector select {\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: white;\n  min-width: 150px;\n}\n\n.compare-toggle label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  color: #555;\n  cursor: pointer;\n}\n\n.compare-toggle input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.refresh-btn {\n  padding: 8px 16px;\n  background: #3498db;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.refresh-btn:hover:not(:disabled) {\n  background: #2980b9;\n}\n\n.refresh-btn:disabled {\n  background: #bdc3c7;\n  cursor: not-allowed;\n}\n\n.analytics-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.overview-card {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  text-align: center;\n  border-left: 4px solid #3498db;\n}\n\n.overview-card h3 {\n  margin: 0 0 10px 0;\n  color: #7f8c8d;\n  font-size: 14px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.overview-value {\n  font-size: 2rem;\n  font-weight: bold;\n  color: #2c3e50;\n  margin: 0;\n}\n\n.analytics-charts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n  margin-bottom: 30px;\n}\n\n.chart-section {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.chart-section h2 {\n  margin: 0 0 20px 0;\n  color: #2c3e50;\n  font-size: 1.3rem;\n  border-bottom: 2px solid #ecf0f1;\n  padding-bottom: 10px;\n}\n\n.zipcodes-details {\n  background: white;\n  padding: 25px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.zipcodes-details h2 {\n  margin: 0 0 20px 0;\n  color: #2c3e50;\n  font-size: 1.3rem;\n  border-bottom: 2px solid #ecf0f1;\n  padding-bottom: 10px;\n}\n\n.zipcodes-table {\n  overflow-x: auto;\n}\n\n.zipcodes-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.zipcodes-table th,\n.zipcodes-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ecf0f1;\n}\n\n.zipcodes-table th {\n  background: #f8f9fa;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.zip-code {\n  font-family: monospace;\n  font-weight: bold;\n  color: #e74c3c;\n}\n\n.view-bookkeepers-btn {\n  padding: 6px 12px;\n  background: #27ae60;\n  color: white;\n  text-decoration: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.view-bookkeepers-btn:hover {\n  background: #219a52;\n}\n\n.loading-spinner {\n  text-align: center;\n  padding: 40px;\n  font-size: 1.1rem;\n  color: #7f8c8d;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .analytics-charts {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .analytics-page {\n    padding: 10px;\n  }\n\n  .analytics-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .analytics-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .period-selector {\n    justify-content: space-between;\n  }\n\n  .analytics-overview {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .analytics-overview {\n    grid-template-columns: 1fr;\n  }\n  \n  .overview-value {\n    font-size: 1.5rem;\n  }\n}\n/* Add to existing Analytics.css */\n\n.comparison {\n  font-size: 0.8rem;\n  font-weight: 600;\n  margin-top: 5px;\n}\n\n.comparison.positive {\n  color: #27ae60;\n}\n\n.comparison.negative {\n  color: #e74c3c;\n}\n\n.overview-value {\n  position: relative;\n}\n\n.comparison-note {\n  background: #e3f2fd;\n  border: 1px solid #2196f3;\n  border-radius: 4px;\n  padding: 10px;\n  margin-top: 10px;\n  font-size: 14px;\n  color: #1565c0;\n}\n\n.comparison-period {\n  background: #fff3cd;\n  border: 1px solid #ffc107;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin: 10px 0;\n  font-size: 14px;\n  color: #856404;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
